(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('.sv-oddit-info .faq-accordion-section').forEach((section) => {
      if (section.dataset.svOdditAccessible) return;
      section.dataset.svOdditAccessible = 'true';
      const tabs = [...section.querySelectorAll('.faq-tab')];
      const panels = [...section.querySelectorAll('.faq-panel')];
      const questions = [...section.querySelectorAll('.faq-question')];
      const prefix = `sv-oddit-info-${section.closest('[id]').id}`;
      const sync = () => {
        tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(panels[index]?.classList.contains('active'))));
        questions.forEach((question) => question.setAttribute('aria-expanded', String(question.closest('.faq-item').classList.contains('open'))));
      };
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'button');
        tab.tabIndex = 0;
        if (panels[index]) {
          panels[index].id ||= `${prefix}-panel-${index}`;
          tab.setAttribute('aria-controls', panels[index].id);
        }
      });
      questions.forEach((question, index) => {
        const answer = question.parentElement.querySelector('.faq-answer');
        question.setAttribute('role', 'button');
        question.tabIndex = 0;
        if (answer) {
          answer.id ||= `${prefix}-answer-${index}`;
          question.setAttribute('aria-controls', answer.id);
        }
        question.querySelector('.arrow-icon')?.setAttribute('aria-hidden', 'true');
      });
      section.addEventListener('keydown', (event) => {
        if (!event.target.matches('.faq-tab, .faq-question')) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.target.click();
        }
      });
      section.addEventListener('click', (event) => {
        if (event.target.closest('.faq-tab, .faq-question')) queueMicrotask(sync);
      });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', () => enhance());
})();
